import { render, staticRenderFns } from "./headline.vue?vue&type=template&id=47d93a11&scoped=true"
import script from "./headline.vue?vue&type=script&lang=ts"
export * from "./headline.vue?vue&type=script&lang=ts"
import style0 from "./headline.vue?vue&type=style&index=0&id=47d93a11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d93a11",
  null
  
)

export default component.exports